import React, { memo }  from 'react';
import IconWrapper from './IconWrapper';

const IconMenu = (props) => (
    <IconWrapper fill={props.fill ? props.fill : "#02263c"} className={`menu ${props.className}`} viewBox="0 0 500 326.1">
        <path d="M0 326.1v-21.8h500V326zM0 173.9v-21.7h500v21.7zM0 21.7V0h500v21.7z" />
    </IconWrapper>
);

export default memo(IconMenu);
